module.exports = __webpack_public_path__ + "static/media/banner1.8cc51376.jpg";